import React from 'react';
import './LoginScreen.css';
import { useNavigate } from 'react-router-dom';
import loginBackground from './loginBackground.svg';
import { CredentialUrls } from '../../dtos/credentials';
import { initOpenIdPresentation } from '../../services/vidcredentials';

interface InitOpenIdPresentationResponse {
  qrBase64: string;
  rawOpenid4vp: string;
}

export default function LoginScreen() {
  const navigate = useNavigate();

  const generatePresentationQr = async (scope?: string) => {
    const retryLocation = CredentialUrls.VALIDATE;
    const response = await initOpenIdPresentation(scope || 'VerifiableAttestation');
    if (!!response && 'error' in response) {
      navigate('/validation-process/failure', { state: { retryLocation } });
      return;
    }
    const initOpenIdPresentationResponse:
    InitOpenIdPresentationResponse = response.data;
    navigate('/login/qrCode', {
      state: {
        qrBase64: initOpenIdPresentationResponse.qrBase64,
      },
    });
  };

  return (
    <div className="login-container">
      <img
        src="/genericBackground.svg"
        alt="genericBackground"
        style={{
          position: 'absolute', top: 0, left: 0, objectFit: 'cover', width: '100vw', height: '100vh', zIndex: -1,
        }}
      />
      {/* Left side - Login Form */}
      <div className="login-left">
        <div className="login-content">
          <img src="/logo.svg" alt="DigitalGov Logo" className="logo" />
          <h2 className="login-heading">
            <span className="login-heading-content">
              <img src="/verticalSeparator.svg" alt="verticalSeparator" className="separator-img" />
              <span>
                Login in to
                <br />
                your account
              </span>
            </span>
          </h2>

          <form className="login-form">
            {/* eslint-disable-next-line
            jsx-a11y/label-has-associated-control */}
            <label htmlFor="email">Email Address</label>
            <div className="input-wrapper">
              <input id="email" type="email" placeholder="myemail@address.com" />
              <span className="icon">
                <img src="/eyeOff.svg" alt="eyeOff Logo" />
                ️
              </span>
            </div>

            {/* eslint-disable-next-line
            jsx-a11y/label-has-associated-control */}
            <label htmlFor="password">Password</label>
            <div className="input-wrapper">
              <input id="password" type="password" placeholder="••••••••" />
              <span className="icon">
                <img src="/eyeOff.svg" alt="eyeOff Logo" />
                ️️
              </span>
            </div>

            <a href="/forgot-password" className="forgot-password">Forgot Password?</a>

            <button type="submit" className="btn primary" onClick={() => { navigate('/issuance/form'); }}>Login with username and password</button>
            <div className="or-divider">Or</div>
            <button onClick={() => generatePresentationQr('AccessBadge')} type="button" className="btn secondary">Log in with your credentials</button>
          </form>
        </div>
        <button type="button" className="back-button-login" onClick={() => navigate('/')}>
          <img src="/goBack.svg" alt="Back Logo" />
          Back
        </button>
      </div>

      {/* Right side - Credential Info */}
      <div className="login-right" style={{ backgroundImage: `url(${loginBackground})` }}>
        <div className="overlay-card">
          <img src="./cardImage.svg" alt="Credential Card" className="card-img" />
          <h3 className="card-heading">
            Present your
            <br />
            {' '}
            credentials to gain access
          </h3>
          <p className="card-desc">
            Access your portal to manage credentials
            that allow you to perform functions more quickly and securely.
          </p>
        </div>
      </div>
    </div>
  );
}
